import { StyleSheet } from 'react-native';
import theme from 'styles';

export default StyleSheet.create({
  schedule: {
    flexDirection: 'row',
  },

  days: {
    marginRight: theme.sizings.medium,
  },
});
